import { ChevronLeft } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Box, Link, Typography } from '@mui/material';
import { useResetPasswordMutation } from 'api/client-domain/client-domain';
import ResetPasswordForm from 'components/forms/reset-password-form/reset-password-form.component';
import { useResetPasswordForm } from 'components/forms/reset-password-form/reset-password-form.hooks';
import LoginLayout from 'components/layouts/login-layout/login-layout.component';
import { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const ResetPassword = () => {
  const { t } = useTranslation();
  const formMethods = useResetPasswordForm();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const [isSuccess, setIsSuccess] = useState(false);

  const onSubmit = async ({ email }) => {
    const { error }: any = await resetPassword(email);
    if (!!error) {
      setIsSuccess(false);
    } else {
      setIsSuccess(true);
    }
  };

  return (
    <LoginLayout>
      {isSuccess ? (
        <>
          <Alert
            sx={{ mb: '12px', mt: '12px' }}
            severity="success"
            data-testid="ResetPassword.SuccessMessage"
          >
            {t('page.resetPassword.successMessage')}
          </Alert>
          <Link
            component={RouterLink}
            to="/login"
            data-testid="ResetPassword.ReturnToLogin"
          >
            <Box display="flex" alignItems="center">
              <ChevronLeft />
              {t('page.resetPassword.returnToLogin')}
            </Box>
          </Link>
        </>
      ) : (
        <>
          <Typography
            variant="body1"
            mt={1}
            textAlign="center"
            data-testid="ResetPassword.Info"
          >
            {t('page.resetPassword.info')}
          </Typography>
          <FormProvider {...formMethods}>
            <Box
              component="form"
              onSubmit={formMethods.handleSubmit(onSubmit)}
              width="100%"
              data-testid="ResetPassword.Form"
            >
              <ResetPasswordForm />

              <LoadingButton
                type="submit"
                fullWidth
                sx={{ mt: 1 }}
                loading={isLoading}
                variant="contained"
                data-testid="ResetPassword.LoadingButton"
              >
                {t('page.resetPassword.submit')}
              </LoadingButton>

              <Box mt={2}>
                <Link
                  component={RouterLink}
                  to="/login"
                  data-testid="ResetPassword.ReturnToLogin"
                >
                  <Box display="flex" alignItems="center">
                    <ChevronLeft />
                    {t('page.resetPassword.returnToLogin')}
                  </Box>
                </Link>
              </Box>
            </Box>
          </FormProvider>
        </>
      )}
    </LoginLayout>
  );
};

export default ResetPassword;
